<template>
  <div id="app">
    <dev-mode-banner />
    <global-error />
    <loading v-if="loading" />
    <div v-else-if="authError" class="auth-error-screen">
      <div class="auth-error-box">
        <h2>Anmeldung nicht möglich</h2>
        <p>
          Es konnte keine Sitzung hergestellt werden. Bitte prüfen Sie Ihren
          Zugang oder wenden Sie sich an den VME-Support.
        </p>
        <button class="btn btn-primary" @click="retryLogin">Erneut anmelden</button>
      </div>
    </div>
    <router-view v-else :key="$route.fullPath" />
  </div>
</template>
<script>
// Vue3-Migration Phase 1b: `vue-msal`-Mixin entfällt — `this.msal` / `this.$msal`
// kommen jetzt aus app.config.globalProperties (siehe src/plugins/msalConfig.js).
import loading from '@/components/common/Loading'
import GlobalError from '@/components/common/GlobalError'
import DevModeBanner from '@/components/common/DevModeBanner'
import { mapState } from 'pinia'
import { useAppStore } from '@/store'
import roleService from '@/services/roleService'
import { consumePostLoginRedirect } from '@/plugins/msalConfig'

export default {
  components: {
    loading,
    GlobalError,
    DevModeBanner
  },
  data() {
    return {
      loading: true,
      authError: false,
      groups: [
        {
          id: '25fae66c-d81b-4fe8-9567-2635d85425e4',
          name: 'seller'
        }
      ],
      userGroup: null,
      usernameRemapping: {
        // 'raphael.golombek@einrichtungspartnerring.com': 'raphael.golombek@einrichtungspartnerring.com1',
        'bianca.thiedemann@moebel-wallach.de': 'th@moebel-wallach.de',
        'ds@.com': 'karin.theilsiefje@polsteraktuell.de',
        'd.fatianova@wohn-schick.de': 'dariia.fatianova@wohn-schick.de',
        'mtak@moebi.at': 'm.tarkashvand@niedermayer.at',
        'awuppinger@niedermayer.at': 'a.wuppinger@niedermayer.at',
        'GmP.Info@niedermayer.at': 'info@gartenmoebelpark.at',
        'ubamschabl@niedermayer.at': 'u.bamschabl@niedermayer.at',
        'bplackner@moebi.at': 'b.plackner@niedermayer.at',
        'areiter@moebi.at': 'a.reiter@niedermayer.at',
        'sfarkas@niedermayer.at': 's.farkas@niedermayer.at',
        'ksv2@moebi.at': 'ksv2@niedermayer.at',
        'vhuber@niedermayer.at': 'v.huber@niedermayer.at',
        'objekt@moebi.at': 'objekt@niedermayer.at',
        'rdanglstaetter@moebi.at': 'r.danglstaetter@niedermayer.at',
        'kroth@niedermayer.at': 'k.roth@niedermayer.at',
        'lmeusburger@moebi.at': 'l.meusburger@niedermayer.at',
        'Niedermayer.IT-Service@niedermayer.at': 'it-service@niedermayer.at',
        'm2@moebi.at': 'm2@niedermayer.at',
        'm12@moebi.at': 'm12@niedermayer.at',
        'mhansmann@moebi.at': 'm.hansmann@niedermayer.at',
        'boutique@moebi.at': 'deko@moebi.at',
        'dhelmer@moebi.at': 'd.helmer@niedermayer.at',
        'ksv1@moebi.at': 'ksv1@niedermayer.at',
        'wbodlos@niedermayer.at': 'w.bodlos@niedermayer.at',
        'lpojer@moebi.at': 'l.pojer@niedermayer.at',
        'm8@moebi.at': 'm8@niedermayer.at',
        'lager.5020@moebi.at': 'lager.5020@niedermayer.at',
        'rbahri@moebi.at': 'r.bahri@niedermayer.at',
        'fschulz@moebi.at': 'f.schulz@niedermayer.at',
        'ks4@moebelniedermayer.onmicrosoft.com': 'ks4@moebigmbh.onmicrosoft.com',
        'machleitner@moebi.at': 'm.achleitner@niedermayer.at',
        'gspoeckinger@moebi.at': 'g.spoeckinger@niedermayer.at',
        'N.Montage@niedermayer.at': 'montage@niedermayer.at',
        'jtripunovic@moebi.at': 'j.tripunovic@niedermayer.at',
        'jlechner@moebi.at': 's.lechner@niedermayer.at',
        'gmatzner@moebi.at': 'g.matzner@niedermayer.at',
        'mhuber@niedermayer.at': 'm.huber@niedermayer.at',
        'jpflugbeil@moebi.at': 'j.pflugbeil@niedermayer.at',
        'Niedermayer.Einkauf@niedermayer.at': 'einkauf@niedermayer.at',
        'mjancic@moebi.at': 'm.jancic@niedermayer.at',
        'Niedermayer-Neues-Wohnen@moebi.at': 'office@moebel-niedermayer.at',
        'kueche@moebi.at': 'kueche@niedermayer.at',
        'bhansmann@moebi.at': 'b.hansmann@niedermayer.at',
        'jsaria@moebi.at': 'j.saria@niedermayer.at',
        'meder@niedermayer.at': 'm.eder@niedermayer.at',
        'pbertich@moebi.at': 'p.bertich@moebi.at',
        'ckoechl@moebi.at': 'c.koechl@niedermayer.at',
        'ks9@niedermayer.at': 'ks3@moebigmbh.onmicrosoft.com',
        'e.com@moebi.at': 'e.com@niedermayer.at',
        'sMilutinovic@moebi.at': 's.milutinovic@niedermayer.at',
        'ks2@moebelniedermayer.onmicrosoft.com': 'ks2@moebigmbh.onmicrosoft.com',
        'munterainer@niedermayer.at': 'm.unterainer@niedermayer.at',
        'm1@moebi.at': 'm1@niedermayer.at',
        'nschrader@moebi.at': 'n.schrader@niedermayer.at',
        'services@moebi.at': 'services@niedermayer.at',
        'mplackner@moebi.at': 'm.plackner@niedermayer.at',
        'bkornberger@moebi.at': 'b.kornberger@niedermayer.at',
        'jortmaier@moebi.at': 'j.ortmaier@niedermayer.at',
        'rKreiter@moebi.at': 'r.kreiter@niedermayer.at',
        'meberhardt@moebi.at': 'm.eberhardt@niedermayer.at',
        'ksv3@moebi.at': 'ksv3@niedermayer.at',
        'areischl@moebi.at': 'a.reischl@niedermayer.at',
        'rechnungseingang@moebi.at': 'rechnungseingang@niedermayer.at',
        'dniedermayer@moebi.at': 'daniel@niedermayer.at',
        'ks1@moebi.at': 'ks1@moebigmbh.onmicrosoft.com',
        'milanjancic@moebi.at': 'milan.jancic@niedermayer.at',
        'fniedermayer@moebi.at': 'felix@niedermayer.at',
        'mniedermayer@moebi.at': 'monika@niedermayer.at',
        'm10@moebi.at': 'm10@niedermayer.at',
        'lstadler@moebi.at': 'lena@niedermayer.at',
        'm11@moebi.at': 'm11@niedermayer.at',
        'ksv4@moebi.at': 'ksv4@niedermayer.at',
        'jniedermayer@moebi.at': 'johann@niedermayer.at',
        'mpisanu@moebi.at': 'm.pisanu@niedermayer.at',
        // Moebelschau Mapping
        'a.arslan@moebelschau-gruppe.de': 'a.arslan@moebelschau.de',
        'n.atapattu@moebelschau-gruppe.de': 'n.atapattu@moebelschau.de',
        'b.buechle@moebelschau-gruppe.de': 'b.buechle@moebelschau.de',
        'p.cammerer@moebelschau-gruppe.de': 'p.cammerer@moebelschau.de',
        't.curia@moebelschau-gruppe.de': 't.curia@moebelschau.de',
        'u.fehrenbach@moebelschau-gruppe.de': 'u.fehrenbach@moebelschau.de',
        'w.gazdek@moebelschau-gruppe.de': 'w.gazdek@moebelschau.de',
        'b.gerold@moebelschau-gruppe.de': 'b.gerold@moebelschau.de',
        'm.hartmann@moebelschau-gruppe.de': 'm.hartmann@moebelschau.de',
        'o.heidt@moebelschau-gruppe.de': 'o.heidt@moebelschau.de',
        'h.hoeldin@moebelschau-gruppe.de': 'h.hoeldin@moebelschau.de',
        't.kersten@moebelschau-gruppe.de': 't.kersten@moebelschau.de',
        'r.knoebel@moebelschau-gruppe.de': 'r.knoebel@moebelschau.de',
        'g.komann@moebelschau-gruppe.de': 'g.komann@moebelschau.de',
        'j.korinth@moebelschau-gruppe.de': 'j.korinth@moebelschau.de',
        'r.krieg@moebelschau-gruppe.de': 'r.krieg@moebelschau.de',
        'm.lepold@moebelschau-gruppe.de': 'm.lepold@moebelschau.de',
        's.lickert@moebelschau-gruppe.de': 's.lickert@moebelschau.de',
        'e.lindinger@moebelschau-gruppe.de': 'e.lindinger@moebelschau.de',
        'm.maier@moebelschau-gruppe.de': 'm.maier@moebelschau.de',
        'p.marschall@moebelschau-gruppe.de': 'p.marschall@moebelschau.de',
        'e.merazzi@moebelschau-gruppe.de': 'e.merazzi@moebelschau.de',
        'w.mueller@moebelschau-gruppe.de': 'w.mueller@moebelschau.de',
        'mo.philipps02@moebelschau-gruppe.de': 'mo.philipps02@moebelschau.de',
        'c.schaare@moebelschau-gruppe.de': 'c.schaare@moebelschau.de',
        'j.schladebach@moebelschau-gruppe.de': 'j.schladebach@moebelschau.de',
        'm.schneider@moebelschau-gruppe.de': 'm.schneider@moebelschau.de',
        'j.sexauer@moebelschau-gruppe.de': 'j.sexauer@moebelschau.de',
        'l.stephan@moebelschau-gruppe.de': 'l.stephan@moebelschau.de',
        'u.redeker@baeucke.onmicrosoft.com': 'hb.heynold@baeucke.de'
      }
    }
  },
  computed: {
    ...mapState(useAppStore, ['getLoadingRoute', 'getUserId']),
    username() {
      return useAppStore().userid
    }
  },
  methods: {
    // Wichtig: gibt ein Promise zurueck und wird in created() abgewartet. Frueher
    // lief das nebenher, waehrend `loading` schon auf false stand — Views pruefen
    // ihre Rollen aber in created(), sodass ein Deeplink auf eine rollengeschuetzte
    // Seite faelschlich nach /access-denied umleiten konnte.
    async updateUserRolesIfPossible() {
      const companyId = sessionStorage.getItem('companyId')
      if (!companyId) {
        return
      }
      console.log('companyId', companyId)
      try {
        const response = await this.$api.selectAccount(companyId)
        const roles = response.data.data.roles
        roleService.clearRoles()
        for (const [key, value] of Object.entries(roles)) {
          if (value) {
            roleService.addRole(key)
          }
        }
      } catch (response) {
        console.error('Error fetching roles:', response)
      }
    },
    // Nach erfolgreicher Anmeldung zurueck zum urspruenglich aufgerufenen Deeplink.
    //
    // Muss abgewartet werden UND vor `loading = false` laufen: Der Redirect von
    // Entra landet immer auf `/`, und `/` ist die Firmenauswahl (Home.vue). Waere
    // der router-view zu diesem Zeitpunkt schon sichtbar, wuerde Home.vue mounten,
    // bei genau einer zugeordneten Firma automatisch `onLogin()` ausfuehren und
    // mit `router.push('/seller')` den gerade wiederhergestellten Deeplink
    // ueberschreiben — der Nutzer landete auf /seller statt auf seiner URL.
    async restorePostLoginRedirect() {
      // Steht noch keine Firma fest (mehrere Zuordnungen, erste Anmeldung), muss
      // zuerst die Auswahl auf Home.vue erfolgen — ohne companyId gibt es keine
      // Rollen, und die Zielseite wuerde nach /access-denied umleiten. Der Marker
      // bleibt in dem Fall bewusst stehen; Home.vue#onLogin loest ihn nach der
      // Auswahl ein.
      if (!sessionStorage.getItem('companyId')) {
        return
      }
      const target = consumePostLoginRedirect()
      if (target && target !== this.$route.fullPath) {
        console.log('Deeplink wiederherstellen:', target)
        try {
          await this.$router.replace(target)
        } catch (e) {
          console.error('Deeplink konnte nicht wiederhergestellt werden:', e)
        }
      }
    },
    retryLogin() {
      sessionStorage.removeItem('msalSignInAttempt')
      this.authError = false
      this.$msal.signIn()
    }
  },
  async created() {
    // Dev-only MSAL bypass — aktiv NUR auf localhost.
    // Greift im Dev-Build (npm run serve) automatisch, damit lokale Browser-Entwicklung
    // ohne Entra-Login läuft. Steuerung:
    //   - sessionStorage 'DEV_MSAL_BYPASS'==='1'      → erzwingen (Playwright via addInitScript)
    //   - config.VUE_APP_DEV_MSAL_BYPASS true/'true' → erzwingen
    //   - config.VUE_APP_DEV_MSAL_BYPASS false/'false' → deaktivieren (echter MSAL-Login lokal)
    // In Produktion doppelt inert: NODE_ENV==='production' UND nie localhost.
    const host = window.location.hostname
    const isLocalhost = host === 'localhost' || host === '127.0.0.1' || host === '[::1]'
    const bypassFlag = typeof config !== 'undefined' ? config.VUE_APP_DEV_MSAL_BYPASS : undefined
    const bypassOff = bypassFlag === false || bypassFlag === 'false'
    const isDevServe = process.env.NODE_ENV !== 'production'
    const bypassEnabled =
      sessionStorage.getItem('DEV_MSAL_BYPASS') === '1' ||
      bypassFlag === true || bypassFlag === 'true' ||
      (isDevServe && !bypassOff)
    if (isLocalhost && bypassEnabled) {
      console.log('DEV_MSAL_BYPASS active (localhost) — skipping MSAL auth')
      if (!sessionStorage.getItem('userId')) {
        sessionStorage.setItem('userId', 'raphael.golombek@einrichtungspartnerring.com')
      }
      // companyId laden, sonst liefert updateUserRolesIfPossible() keine Rollen.
      const companyId = sessionStorage.getItem('companyId')
      if (!companyId) {
        this.$api.getCurrentMerchant().then(response => {
          const merchantId = response?.data?.data?.merchantId
          if (merchantId) {
            sessionStorage.setItem('companyId', merchantId)
          }
          this.updateUserRolesIfPossible()
        }).catch(err => {
          console.error('Error fetching current merchant (dev bypass):', err)
          this.updateUserRolesIfPossible()
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.updateUserRolesIfPossible()
        this.loading = false
      }
      return
    }
    const res = this.msal.isAuthenticated
    if (res) {
      // Erfolgreich authentifiziert -> Loop-Schutz-Marker zuruecksetzen.
      sessionStorage.removeItem('msalSignInAttempt')
      let username = ''
      if (this.msal?.user?.userName) {
        username = this.msal.user.userName
        console.log('checking if remapping is needed', username)
        if (this.usernameRemapping && username in this.usernameRemapping) {
          username = this.usernameRemapping[username]
          console.log('remapped to', username)
        }
      }

      // Robustheit: Meldet sich ein ANDERER Nutzer an als zuletzt, darf dessen
      // companyId/Rollen nicht weiterverwendet werden. Sonst laeuft selectAccount()
      // gegen eine fremde Firma -> Backend antwortet 404 ACCOUNT_NOT_FOUND
      // ("Selected company not found or its not connected to user ...").
      const previousUserId = sessionStorage.getItem('userId')
      if (previousUserId && username && previousUserId !== username) {
        console.log('Benutzerwechsel erkannt:', previousUserId, '->', username, '- companyId und Rollen werden zurueckgesetzt')
        sessionStorage.removeItem('companyId')
        roleService.clearRoles()
      }

      sessionStorage.setItem('userId', username)
      console.log('user is authenticated on created')
      const companyId = sessionStorage.getItem('companyId')
      // Bewusst abgewartet: erst wenn companyId feststeht, koennen die Rollen
      // geladen werden - und erst danach darf die Route gerendert werden.
      if (!companyId) {
        try {
          const response = await this.$api.getCurrentMerchant()
          // if the user has a configured profile, use the merchantId
          if (response.data && response.data.data && response.data.data.merchantId) {
            sessionStorage.setItem('companyId', response.data.data.merchantId)
          }
        } catch (err) {
          console.error('Error fetching current merchant:', err)
        }
      } else {
        try {
          const response = await this.$api.getCurrentMerchant()
          if (response.data && response.data.data && response.data.data.merchantId == null) {
            this.$api.setCurrentMerchant(username, companyId).catch(() => {})
            console.log('merchant id present in local storage but not in db, setting current merchant for user', username, 'to', companyId)
          }
        } catch (err) {
          console.error('Error fetching current merchant:', err)
        }
      }
      await this.updateUserRolesIfPossible()
      // Erst jetzt, mit geladenen Rollen, zurueck zum urspruenglichen Deeplink —
      // und noch vor dem Rendern des router-view (siehe restorePostLoginRedirect).
      await this.restorePostLoginRedirect()
      this.loading = false
    } else {
      console.log('----user not authenticated on created------\n')
      // Loop-Schutz: Kommt der Redirect ohne etablierte Session zurueck (Azure-Login
      // fehlgeschlagen / invalid_request / kein Kontozugriff), NICHT erneut blind
      // umleiten -> sonst Endlos-Redirect-Loop. Max. ein Versuch pro Tab-Session;
      // danach Fehlermeldung statt weiterer Redirect.
      if (sessionStorage.getItem('msalSignInAttempt')) {
        sessionStorage.removeItem('msalSignInAttempt')
        console.error('MSAL sign-in returned without an authenticated session — stopping redirect loop')
        this.authError = true
        this.loading = false
        return
      }
      sessionStorage.setItem('msalSignInAttempt', '1')
      this.$msal.signIn()
    }
  }
}
</script>
<style lang="scss">
@import "assets/scss/main.scss";

.auth-error-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  text-align: center;
}
.auth-error-box {
  max-width: 480px;

  h2 {
    margin-bottom: 1rem;
  }
  p {
    margin-bottom: 1.5rem;
  }
}
</style>
